var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} // TEST!!!
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NeedAuthorization } from "../../Auth";
import { t } from "../../I18N";
import { Icon } from "../../UI";

import * as actions from "../actions/actions";

class RelationshipsFormButtons extends Component {
  constructor(props) {
    super(props);
    this.edit = this.edit.bind(this);
  }

  componentWillUnmount() {
    this.edit(false)();
  }

  edit(value) {
    return () => {
      this.props.edit(value, this.props.searchResults, this.props.parentEntity);
    };
  }

  render() {
    const { editing, saving } = this.props;
    const entityData = this.props.parentEntity.toJS();

    return (/*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [entityData] }, void 0,
      !editing && /*#__PURE__*/
      _jsx("div", { className: "btn-cluster" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: this.edit(true),
        className: "edit-metadata btn btn-default" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "pencil-alt" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Edit'))
      )
      )

      ), /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [entityData] }, void 0,
      editing && /*#__PURE__*/
      _jsx("div", { className: "btn-cluster content-right" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: this.edit(false),
        className: "cancel-edit-metadata btn btn-default btn-extra-padding" }, void 0, /*#__PURE__*/

      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Cancel'))
      ), /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: this.props.save,
        className: "btn btn-success btn-extra-padding",
        disabled: saving }, void 0,

      saving && /*#__PURE__*/_jsx(Icon, { icon: "spinner", pulse: true, fixedWidth: true }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Save'))
      )
      )

      )
      ));

  }
}










const mapStateToProps = ({ relationships }) => ({
  editing: relationships.hubActions.get('editing'),
  saving: relationships.hubActions.get('saving'),
  parentEntity: relationships.list.entity,
  searchResults: relationships.list.searchResults
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      edit: actions.edit,
      save: actions.saveRelationships
    },
    dispatch
  );
}

export { RelationshipsFormButtons };

export default connect(mapStateToProps, mapDispatchToProps)(RelationshipsFormButtons);